import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n  width: 100%;\n'], ['\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n  width: 100%;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  flex: 1 1 auto;\n'], ['\n  display: flex;\n  flex: 1 1 auto;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  flex: 1 0 auto;\n  transition: max-height 0.25s ease-in-out;\n  max-height: ', 'px; /* 52 is line height (20) + 4*grid */\n  position: relative;\n  width: 100%;\n  z-index: 3;\n'], ['\n  flex: 1 0 auto;\n  transition: max-height 0.25s ease-in-out;\n  max-height: ', 'px; /* 52 is line height (20) + 4*grid */\n  position: relative;\n  width: 100%;\n  z-index: 3;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  position: fixed;\n  width: 100%;\n'], ['\n  position: fixed;\n  width: 100%;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  position: relative;\n  z-index: 2;\n'], ['\n  position: relative;\n  z-index: 2;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  flex: 1 1 auto;\n  position: relative;\n  z-index: 1;\n  min-width: 0;\n'], ['\n  flex: 1 1 auto;\n  position: relative;\n  z-index: 1;\n  min-width: 0;\n']);

import React, { Component } from 'react';
import styled, { ThemeProvider } from 'styled-components';

var Wrapper = styled.div(_templateObject);

var NavigationAndContent = styled.div(_templateObject2);

var BannerContainer = styled.div(_templateObject3, function (props) {
  return props.isBannerOpen ? 52 : 0;
});

var Banner = styled.div(_templateObject4);

var Navigation = styled.div(_templateObject5);

var PageContent = styled.div(_templateObject6);

var emptyTheme = {};

var Page = function (_Component) {
  _inherits(Page, _Component);

  function Page() {
    _classCallCheck(this, Page);

    return _possibleConstructorReturn(this, (Page.__proto__ || _Object$getPrototypeOf(Page)).apply(this, arguments));
  }

  _createClass(Page, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        ThemeProvider,
        { theme: emptyTheme },
        React.createElement(
          Wrapper,
          null,
          this.props.banner ? React.createElement(
            BannerContainer,
            {
              'aria-hidden': this.props.isBannerOpen,
              isBannerOpen: this.props.isBannerOpen
            },
            React.createElement(
              Banner,
              null,
              this.props.banner
            )
          ) : null,
          React.createElement(
            NavigationAndContent,
            null,
            React.createElement(
              Navigation,
              null,
              this.props.navigation
            ),
            React.createElement(
              PageContent,
              null,
              this.props.children
            )
          )
        )
      );
    }
  }]);

  return Page;
}(Component);

Page.displayName = 'AkPage';
Page.defaultProps = {
  isBannerOpen: false
};
export default Page;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/page/dist/esm/Page.js
// module id = 267
// module chunks = 0